import { useCreateUserMutation } from 'generated/graphql';
import AuthService from 'services/AuthService';
import { EdgeServerUserInput } from 'v2/views/layouts/authenticationModule/authTypes';

interface CreateUserOnEdgeServerInput {
  payload: EdgeServerUserInput;
  onCompleted?: () => void;
  onError?: (err: Error) => void;
}

const useCreateUserOnEdgeServer = ({
  payload,
  onCompleted,
  onError,
}: CreateUserOnEdgeServerInput) => {
  const tenantSlug: string = AuthService.getTenantSlug();

  const [createUserMutation, { error, loading }] = useCreateUserMutation({
    variables: {
      email: payload.email,
      firstName: payload.firstName,
      lastName: payload.lastName,
      role: payload.role,
      slug: tenantSlug,
    },
    onCompleted: onCompleted,
    onError: onError,
  });

  return { createUser: createUserMutation, error, loading };
};
export default useCreateUserOnEdgeServer;
